import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { PortfolioHoldingResponse } from 'src/app/models/portfolio-models/portfolio-holding-response.model'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'

@Component({
  selector: 'money-market-results',
  templateUrl: './money-market-results.component.html',
  styleUrls: ['./money-market-results.component.scss'],
  providers: [],
})
export class MoneyMarketResultsComponent implements OnInit, OnDestroy {
  @Input() moneyMarketResults: PortfolioHoldingResponse

  @ViewChild('effectiveMaturityContent', { static: false })
  public effectiveMaturityContent: TemplateRef<any>
  @ViewChild('finalMaturityContent', { static: false })
  public finalMaturityContent: TemplateRef<any>

  //AEM content variables
  finalMaturityDateDefinition: AEMChunk
  effectiveMaturityDateDefinition: AEMChunk
  aemContentSub: Subscription

  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
  ) {}

  ngOnInit(): void {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
    this.finalMaturityDateDefinition =
      this.centralContentService.getContentByBody(
        'fund_definitions_final_maturity_date',
        content,
      )
    this.effectiveMaturityDateDefinition =
      this.centralContentService.getContentByBody(
        'fund_definitions_effective_maturity_date',
        content,
      )
  }

  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
